import React from 'react'
import "./bufferloader.scss"
const BufferLoader = ({className}) => {
  return (
    <div className={`lds-buffer-spinner ${className}`}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
     
    </div>
  );
}

export default BufferLoader